import { QuoteMaxPaymentsEnum } from "../shared/enums";
import { ExchangeRateDate } from "./ExchangeRateDate";

export const quoteMaxPaymentsOptions = [
    { id: QuoteMaxPaymentsEnum.UN_PAGO, name: '1 pago' },
    { id: QuoteMaxPaymentsEnum.HASTA_DOS_PAGOS, name: 'Hasta 2 pagos' }
];

export interface QuoteInvoicingDataForm {
    id?: number;
    quote_id: number;
    payment_condition_id: number;
    payment_method_id: number;
    currency_id: number;

    use_standard_weight?: boolean;
    standard_weight_value?: number | string | null;
    standard_weight_unit_id?: number | string | null;
    standard_weight_lower_limit?: number | string | null;
    standard_weight_lower_limit_unit_id?: number | string | null;

    preliminary_exchange_rate_date_reference?: string; // enum: ExchangeRateDate
    final_exchange_rate_date_reference?: string;       // enum: ExchangeRateDate

    preliminary_exchange_rate_date?: string;
    final_exchange_rate_date?: string;

    exchange_rate_date_source?: string; // enum: ExchangeRateDateSource
    reference?: string;

    preliminary_days?: string;
    preliminary_months?: string;
    preliminary_year?: string;
    final_year?: string;
    preliminary_fixed_date?: string;

    final_months?: string;
    final_days?: string;
    final_fixed_date?: string;

    days_count?: number;
    max_payments?: string;
    expired_at: string;
    expired_in_days?: number;


    created_at?: string;
    updated_at?: string;
}

export const defaultQuoteInvoicingDataForm: QuoteInvoicingDataForm = {
    quote_id: 0,
    expired_at: '',
    expired_in_days: 0,
    payment_condition_id: 0,
    payment_method_id: 0,
    currency_id: 0,
    max_payments: QuoteMaxPaymentsEnum.UN_PAGO,
    use_standard_weight: false,
    standard_weight_value: null,
    standard_weight_unit_id: null,
    standard_weight_lower_limit: null,
    standard_weight_lower_limit_unit_id: null,
    preliminary_exchange_rate_date_reference: '',
    final_exchange_rate_date_reference: '',
    exchange_rate_date_source: ''
};



export interface QuoteInvoicingShowDataForm {
    id?: number;
    quote_id?: number;

    payment_method?: string;
    payment_condition?: string;
    currency?: string;

    preliminary_exchange_rate_date_reference?: ExchangeRateDate; 
    preliminary_exchange_rate_date_reference_value?: string; 

    final_exchange_rate_date_reference?: ExchangeRateDate;       
    final_exchange_rate_date_reference_value?: string;       

    preliminary_exchange_rate_date?: string;   
    final_exchange_rate_date?: string;
    reference?: string;
    days_count?: number;
    max_payments?: string;
    max_payments_value?: string;

    preliminary_days?: string;
    preliminary_months?: string;
    preliminary_year?: string;
    preliminary_fixed_date?: string;

    final_months?: string;
    final_days?: string;
    final_year?: string;
    final_fixed_date?: string;

    exchange_rate_date_source?: string;               

    expired_in_days?: number;

    created_at?: string;
    updated_at?: string;
}
